/* eslint-disable camelcase */
import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { AuthDecorator } from '@components/auth-decorator';
import { Button, Tezos } from '@components/design-system';
import { IToken } from '@interface/token';
import { swapCollect } from '@lib/beacon';
import { actions } from '@state/modals';
import { MutToTez } from '@utils/format';

interface ICollect {
  swap_id: number;
  current_price: number;
  start_price: number;
  end_price: number;
  amount: number;
  amount_left: number;
  token: IToken;
}

export const Collect: FC<ICollect> = ({
  swap_id,
  start_price,
  end_price,
  amount,
  amount_left,
  current_price,
  token,
}) => {
  const dispatch = useDispatch();
  const isAdvanced = start_price !== end_price;

  const handleCollect = async () => {
    if (isAdvanced) {
      dispatch({
        type: actions.MODALS_SET_MODAL,
        payload: {
          type: 'swap-slippage',
          swapId: swap_id,
          startPrice: start_price,
          endPrice: end_price,
          amount,
          amountLeft: amount_left,
          creatorsTotal: token.creators.length,
        },
      });
    } else {
      swapCollect(swap_id, current_price, 1, token.creators.length);
    }
  };

  // if isAdvanced we need to fire a new modal
  return (
    <AuthDecorator onClick={handleCollect}>
      <Button full variant="primary">
        {`Collect for ${MutToTez(current_price)}`}
        <Tezos />
      </Button>
    </AuthDecorator>
  );
};
